//Context of this file - Gets data from Indexed DB (functions inside LDBfunction.js) and computes it and returns it to populate charts

import { get_data_of_exercise } from "./LDBfunctions.js";


const load_from_memory = false; // if made true, all functions loads data from memory instead of DB

//#region COMPUTE FUNCTONS  -----------------------------------------------------------------------------------------------------------------------





export async function total_volume(from, to, ex_id) {
  const excercise_title = get_excercise_title(ex_id);
  let data = [];
  data = await get_data_of_exercise(from, to, excercise_title); //array between from and to dates of specific excercise
  const chartData = [];
  const regressionLine = [];

  //vars for linear regression
  const n = data.length;
  let sumX = 0;
  let sumY = 0;
  let sumXY = 0;
  let sumXX = 0;

  data.map((record, index) => { //each record is one date.
    const start_time = new Date(record.start_time);
    const sets = record.sets;
    const volume_array = []; // multiples rep x weight_kg and stores as arrow

    sets.map((set) => {
      volume_array.push(set.weight_kg * set.reps);
    });

    const total_volume = volume_array.reduce((acc, curr) => acc + curr, 0);
    
    // For linear regression calculation
    sumX += index;
    sumY += total_volume;
    sumXY += index * total_volume;
    sumXX += index * index;

    chartData.push({
      y: total_volume,
      x: make_readable_date(start_time)
    });
  });

  // Calculate regression line
  const slope = (n * sumXY - sumX * sumY) / (n * sumXX - sumX * sumX);
  const intercept = (sumY - slope * sumX) / n;

  // Add regression values to chartData
  chartData.forEach((point, index) => {
    point.z = slope * index + intercept;
  });

  return {
    chartData,
    slope
  };
  
}



export async function PRprogression(from, to, ex_id) {
  const excercise_title = get_excercise_title(ex_id);

  let data = [];

  if (!load_from_memory) {
    // Load from DB
    data = await get_data_of_exercise(from, to, excercise_title); // array between from and to dates of specific exercise
  }

  //  console.log('no of records to compute PR Progresson: ', data.length);

  const chartData = [];

  data.forEach((record) => {
    let heaviest_weight = 0.0; // Use let since the value is updated

    const sets = record.sets;

    sets.forEach((set) => {
      if (set.weight_kg > heaviest_weight) {
        heaviest_weight = set.weight_kg;
      }
    });

    chartData.push({
      y: heaviest_weight,
      x: make_readable_date(record.start_time),
    });
  });

  // console.log('chartData: ', chartData);

  return chartData;
}

export async function oneRM(from, to, ex_id) {
  const excercise_title = get_excercise_title(ex_id);

  let data = [];

  if (!load_from_memory) {
    // Load from DB
    data = await get_data_of_exercise(from, to, excercise_title); // array between from and to dates of specific exercise
  }
  // console.log('no of records to compute one RM: ', data.length);

  //  console.log('records to compute one RM: ', data);

  const chartData = [];

  data.forEach((record) => {
    let rolling_1RM = 0;

    const sets = record.sets;

    sets.forEach((set) => {
      sets.set_index = sets.set_index + 1;

      const RM = set.weight_kg * (1 + set.reps / 30);

      rolling_1RM = rolling_1RM + RM;
    });

    const sets_count = sets.length;

    const average_1RM = rolling_1RM / sets_count;

    rolling_1RM = 0;

    //push to chartData;

    chartData.push({
      y: average_1RM,
      x: make_readable_date(record.start_time),
    });
  });

  return chartData;
}

export async function bestSetVolume(from, to, ex_id) {
  const excercise_title = get_excercise_title(ex_id);

  let data = [];

  if (!load_from_memory) {
    // Load from DB
    data = await get_data_of_exercise(from, to, excercise_title); // array between from and to dates of specific exercise
  }
  //console.log('no of records to compute best set volume: ', data.length);

  // console.log('records to compute best set volume: ', data);

  const chartData = [];

  data.forEach((record) => {
    let bestSetVolume = 0; // To store the best set volume for the workout session

    const sets = record.sets;

    sets.forEach((set) => {
      // Calculate the volume for the current set
      const setVolume = set.weight_kg * set.reps;

      // Update the best set volume if the current set volume is greater
      bestSetVolume = Math.max(bestSetVolume, setVolume);
    });

    // Push the best set volume along with the date to chartData
    chartData.push({
      y: bestSetVolume,
      x: make_readable_date(record.start_time),
    });
  });

  //  console.log('chartData: ', chartData);
  return chartData;
}

export async function totalreps(from, to, ex_id) {
  const excercise_title = get_excercise_title(ex_id);

  let data = [];

  if (!load_from_memory) {
    // Load from DB
    data = await get_data_of_exercise(from, to, excercise_title); // array between from and to dates of specific exercise
  }
  //   console.log('no of records to compute best set volume: ', data.length);

  //  console.log('records to compute best set volume: ', data);

  const chartData = [];

  data.forEach((record) => {
    let totalReps = 0;

    const sets = record.sets;

    sets.forEach((set) => {
      totalReps += set.reps;
    });

    chartData.push({
      y: totalReps,
      x: make_readable_date(record.start_time),
    });
  });

  //  console.log('chartData: ', chartData);
  return chartData;
}

//#endregion COMPUTE FUNCTONS

//------------------------------------------------
//------------------------------------------------

//#region HELPER FUNCTIONS-------------------------------------------------------------------------------------------------------------------------

export function get_excercise_title(ex_id) {
  if (ex_id == 1) {
    return "Incline Bench Press (Dumbbell)";
  } else {
    console.log("WRONG EXCERCISE ID: Not found");
  }
}

export function get_excercise_id(ex_id) {
  if (ex_id == "Incline Bench Press (Dumbbell)") {
    return 1;
  } else {
    console.log("WRONG EXCERCISE ID: Not found");
  }
}

export function make_readable_date(timestamp) {
  const style = 1;

  if (style == 1) {
    const dateObj = new Date(timestamp);
    const year = dateObj.getFullYear();
    const month = dateObj
      .toLocaleString("default", { month: "short" })
      .toUpperCase(); // Get the abbreviated month name
    const day = `0${dateObj.getDate()}`.slice(-2);

    // Return the formatted date in the desired format
    return `${day} ${month} ${year.toString().slice(-2)}`; // '23' for the year
  } else {
    const dateObj = new Date(timestamp);
    const year = dateObj.getFullYear();
    const month = `0${dateObj.getMonth() + 1}`.slice(-2);
    const day = `0${dateObj.getDate()}`.slice(-2);

    return `${year}-${month}-${day}`;
  }
}

//#endregion HELPER FUNCTIONS

//#region Backups  ---------------------------------------------------------------------------------------------------------------------------------

export async function template(from, to, ex_id) {
  const excercise_title = get_excercise_title(ex_id);

  const data = await get_data_of_exercise(from, to, excercise_title); //array between from and to dates of specific excercise

  const chartData = [];

  data.map((record) => {
    chartData.push({
      y: record.weight_kg * record.reps,
      x: record.start_time,
    });
  });
}

//#endregion Backups
